module.exports = __webpack_public_path__ + "img/xp-shadow.a8719054.png";